import { Group, Checkin } from "~/types";
import { slugify } from "./slugify";
import get from "lodash/get";

export const groups: Group[] = [
  {
    pathPrefix: "region",
    group: "area",
    displayName: "coffees grown in",
  },
  {
    pathPrefix: "roaster",
    group: "roaster",
    displayName: "roaster",
  },
  {
    pathPrefix: "brand",
    group: "brand",
    displayName: "brand",
  },
  {
    pathPrefix: "brewing-method",
    group: "brewingMethod",
    displayName: "brewing method",
  },
  {
    pathPrefix: "country",
    group: "country",
    displayName: "coffees grown in",
  },
  {
    pathPrefix: "processing-method",
    group: "processingMethod",
    displayName: "processing method",
  },
  {
    pathPrefix: "producer",
    group: "producer",
    displayName: "producer",
  },
  {
    pathPrefix: "name",
    group: "title",
    displayName: "coffee name",
  },
  {
    pathPrefix: "varietal",
    group: "varietal",
    displayName: "varietal",
  },
  {
    pathPrefix: "cafe",
    group: "venue.name",
    displayName: "café",
  },
  {
    pathPrefix: "location/city",
    group: "venue.location.city",
    displayName: "cafés in",
  },
  {
    pathPrefix: "location/state",
    group: "venue.location.state",
    displayName: "cafés in",
  },
  {
    pathPrefix: "location/country",
    group: "venue.location.country",
    displayName: "cafés in",
  },
  {
    path: "loved",
    group: "like",
    displayName: "loved",
  },
];

export const getGroupDefinition = (
  group?: (typeof groups)[number]["group"] | string
): Group | undefined =>
  group
    ? groups.find((obj) => slugify(obj.group) === slugify(group))
    : undefined;

export const getGroupedCheckins = (
  checkins: Checkin[],
  group: Group["group"],
  groupValue?: string
) => {
  if (group === "like") return checkins.filter((checkin) => checkin.like);
  if (!groupValue || typeof groupValue !== "string") return checkins;

  return checkins.filter(
    (checkin) =>
      get(checkin, group) &&
      typeof get(checkin, group) === "string" &&
      slugify(get(checkin, group)) === slugify(groupValue)
  );
};
